import { render, staticRenderFns } from "./ChampionshipQualifiers.vue?vue&type=template&id=20cc5705&scoped=true"
import script from "./ChampionshipQualifiers.vue?vue&type=script&lang=js"
export * from "./ChampionshipQualifiers.vue?vue&type=script&lang=js"
import style0 from "./ChampionshipQualifiers.vue?vue&type=style&index=0&id=20cc5705&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cc5705",
  null
  
)

export default component.exports